import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;
declare var page: any;
declare var Dropzone: any;


export class jobApplicationsEdit_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected roleFilter: filterDropdown_template;
    protected resultInfos: resultsInfo_template;
    protected resumeTooltip : infoButton_template;
    protected coverLetterTooltip : infoButton_template;
    protected imagesSampleTooltip : infoButton_template;
    protected validationsList: validationsList_template;

    protected getTemplateHtml(): string {

        return `

            ` + this.validationsList.getHtmlBuild() + `
            <div class="w-form-2-column">
                
                    <div class="w-form w-form-large">
                    
                        <div class="form-header">
                            <span></span> 
                            <h3 class="form-title" data-bind="text: positionTitle, css: brandIcon"></h3>
                            <span></span>                       
                        </div>
                        
                        <div class="form-pagination" data-bind="visible: !isCandidate()">
                            <button class="btn icon is-activated" type="button" data-bind="event:{click: onClickTab.bind($data, 'application')}, css: { 'is-activated' : selectedTab() == 'application'}">Application</button>
                            <button class="btn icon nbr" type="button" data-bind="event:{click: onClickTab.bind($data, 'internalNotes')}, css: { 'is-activated' : selectedTab() == 'internalNotes'}">Internal Notes<span data-bind="visible: (internalNotes().length + applicationHistory().length + offboardingHistory().length) > 0, text: internalNotes().length + applicationHistory().length + offboardingHistory().length"></span></button>
                        </div>
                        
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'application'}"> 
                        
                            <div class="w-form-body header">
                                <div class="header-bg" data-bind="style:{backgroundImage: 'url(' + jobProfileImageUrl() + ')'}"></div>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label for="" class="form-label">candidate name</label>
                                        <div style="display: flex;flex-direction: row" >
                                            <span class="form-view-text" data-bind="text: candidateName"></span>
                                            <!-- ko if: permissions()['users_list'].write -->
                                            <div style="margin-left: 1rem">
                                                <a data-bind="attr:{href: candidateProfileLink()}" target="_blank" class="btn border only-icon icon i-go-to"></a><span class="hide-text"></span></a>
                                            </div>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                     <div class="form-group">
                                        <label for="" class="form-label">candidate email</label>
                                        <span class="form-view-text" style="text-transform: lowercase;" data-bind="text: candidateEmail"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">position title</label>
                                        <div style="display: flex;flex-direction: row" >
                                            <span class="form-view-text" data-bind="text: positionTitle"></span>
                                            <!-- ko if: permissions()['job_profiles'].write -->
                                            <div data-bind="if: !isCandidate()" style="margin-left: 1rem">
                                                <a data-bind="attr:{href: jobProfileViewLink()}" target="_blank" class="btn border only-icon icon i-go-to"></a><span class="hide-text"></span></a>
                                            </div>
                                             <!-- /ko -->
                                        </div>
                                    </div>
                                
                                </div>
                                <div class="form-body">
                                     <div class="form-group">
                                        <label for="" class="form-label">user role</label>
                                        <span class="form-view-text" data-bind="text: userRoles"></span>
                                    </div>
                                     <div class="form-group">
                                        <label for="" class="form-label">country</label>
                                        <span class="form-view-text" data-bind="text: country"></span>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">user brands</label>
                                        <ul class="brand-list" data-bind="foreach: userBrands">
                                            <li class="brand-item full-icon" data-bind="css: iconImage"></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- ko if: (resume() &&  resume().id > 1 ) || (coverLetter() && coverLetter().id > 1) -->
                            <div class="w-form-body section">                                
                                <div class="form-body">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['files']">
                                            <span class="step-num" data-bind="text: stepsDetails()['files'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">application files</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['files'].completed >= stepsDetails()['files'].required)}"></span>
                                        </div>
                                    </div>
                                    <div class="form-group" data-bind="if: resume() && resume().id > 1">
                                        <div style="display: flex;align-items: center;">
                                            <span class="sub-title">Resume<span data-bind="visible: resume().id == 2 || resume().id == 3" class="form-required">* required</span></span>
                                            <div class="w-tooltips-adv pos-top mini">
                                                ` + this.resumeTooltip.getHtmlBuild() + `
                                            </div>
                                        </div>
                                        <div id="dropzone" class="">
                                            <div id="my-drop-zone-resume" class="dropzone needsclick dz-clickable large"></div>
                                            <input id="resume-pic" data-bind="value: resume" type="hidden">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-body"> 
                                    <div class="form-group" data-bind="if: coverLetter() && coverLetter().id > 1">
                                        <div style="display: flex;align-items: center;">      
                                            <span class="sub-title">Cover Letter<span data-bind="visible: coverLetter().id == 2 || coverLetter().id == 3" class="form-required">* required</span></span>
                                            <div class="w-tooltips-adv pos-top mini">
                                                ` + this.coverLetterTooltip.getHtmlBuild() + `
                                            </div>
                                        </div>
                                        <div id="dropzone">
                                            <div id="my-drop-zone-coverLetter" class="dropzone needsclick dz-clickable large"></div>
                                        </div>
                                    </div>   
                                </div>
                            </div>
                            <!-- /ko -->     
                                    
                            <!-- ko if: referentialWork() && referentialWork().id > 1-->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['referentialWork']">
                                            <span class="step-num" data-bind="text: stepsDetails()['referentialWork'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">Referential work</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['referentialWork'].completed >= stepsDetails()['referentialWork'].required)}"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: referentialWork().instructions">
                                        <span class="sub-title">Instructions</span>
                                        <div class="step-instruction" data-bind="html: referentialWork().instructions"></div>
                                    </div>
                                   
                                   <div data-bind="foreach: referentialWork().links">
                                        <div class="form-group referential-work">
                                            <label data-bind="attr: { for: 'link' + $index()}" class="form-label">Link<span data-bind="visible: $parent.referentialWork().id == 2 || $parent.referentialWork().id == 3" class="form-required">* required</span></label>
                                            <input data-bind="attr: { id: 'link' + $index()},  value: $rawData, event:{change : $parent.onUpdateReferentialLink}" type="text" class="input-text">
                                        </div>
                                   </div>                                  

                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: writtenSample() &&  writtenSample().id > 1 || writtenSampleText()-->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['writtenSample']">
                                            <span class="step-num" data-bind="text: stepsDetails()['writtenSample'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">Written Sample</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['writtenSample'].completed >= stepsDetails()['writtenSample'].required)}"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: writtenSample() &&  writtenSample().id > 1 && writtenSample().instructions">
                                        <span class="sub-title">Instructions</span>
                                        
                                        <div class="step-instruction" data-bind="html: writtenSample().instructions"></div>
                                    </div>
                                   
                                    <div class="form-group" data-bind="if: writtenSampleText()">
                                        <span class="form-required" data-bind="if: writtenSample().id == 2 || writtenSample().id == 3">* required</span>
                                        <textarea class="form-text rich-text " id="writtenSample"></textarea>
                                    </div>
                                   
                                    <div class="form-group" data-bind="if: !writtenSampleText()">
                                        <div id="dropzone">
                                            <div id="my-drop-zone-writtenSample" class="dropzone needsclick dz-clickable large"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: imageSample() && imageSample().id > 1-->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step">
                                        <div class="step" data-bind="if: stepsDetails()['imageSample']">
                                            <span class="step-num" data-bind="text: stepsDetails()['imageSample'].current"></span>
                                            <div class="w-info">
                                                <div style="display: flex;align-items: center;">    
                                                    <span class="step-title">image sample</span>
                                                    <div class="w-tooltips-adv pos-top mini" style="transform: translateY(-3px)">
                                                         ` + this.imagesSampleTooltip.getHtmlBuild() + `
                                                    </div>
                                                </div> 
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['imageSample'].completed >= stepsDetails()['imageSample'].required)}"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="form-group" data-bind="if: imageSample().instructions">
                                        <span class="sub-title">Instructions</span>
                                        <div class="step-instruction" data-bind="html: imageSample().instructions"></div>
                                    </div>
                                   
                                    <div class="form-group">
                                        <span data-bind="if: imageSample().id == 2 || imageSample().id == 3" class="form-required">* required</span>
                                        <div id="dropzone">
                                            <div id="my-drop-zone-picture" class="dropzone needsclick dz-clickable large"></div>
                                        </div>
                                    </div>
                        
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: answers() && answers().length > 0 -->
                            <div class="w-form-body section">                                
                                <div class="form-body full-width">
                                    <div class="w-step ">
                                        <div class="step" data-bind="if: stepsDetails()['answers']">
                                            <span class="step-num" data-bind="text: stepsDetails()['answers'].current"></span>
                                            <div class="w-info">
                                                <span class="step-title">Questions</span>
                                            </div>
                                            <span data-bind="css : { 'step-check icon i-check is-visible' : (stepsDetails()['answers'].completed >= stepsDetails()['answers'].required)}"></span>
                                        </div>
                                    </div>
                                   
                                   <div class="form-group">
                                        <ul class="question-list" data-bind="foreach: answers">
                                            <li class="question-item">
                                            
                                                <div class="step-question">
                                                    <p class="comment" data-bind="html: question"> </p><span data-bind="visible: id == 2 || id == 3" class="required"> * required</span>
                                                </div>
                                                <div class="step-answer">
                                                   <textarea class="comment" data-bind="value: answer, event:{change : $parent.onUpdateAnswer}"> </textarea>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>
                        
                        <div class="w-tabs-content" data-bind="css: { 'is-showing' : selectedTab() == 'internalNotes' && !isCandidate()}"> 
                            
                            <div class="form-body section internal-notes" id="internal-notes">
                                <div class="form-body">
                                    <div class="form-group form-comment">
                                        <div class="history-cards">
                                            <div class="card total-history no-hover">
                                                <h2>Total<br>Internal Notes</h2>
                                                <span class="count" data-bind="text: applicationHistory().length + offboardingHistory().length + internalNotes().length"></span>
                                            </div>
                                            <button class="card app-history" data-bind="click: () => scrollToSection('application-history-section')">
                                                <span class="icon i-samples"></span>
                                                <span class="count" data-bind="text: applicationHistory().length"></span>
                                                <h2>Application<br>History</h2>
                                            </button>
                                            <button class="card brand-history" data-bind="click: () => scrollToSection('brand-access-notes-section')">
                                                <span class="icon i-brand"></span>
                                                <span class="count" data-bind="text: offboardingHistory().length"></span>
                                                <h2>Brand<br>Access Notes</h2>
                                            </button>
                                            <button class="card internal-notes" data-bind="click: () => scrollToSection('internal-comments-section')">
                                                <span class="icon i-notes"></span>
                                                <span class="count" data-bind="text: internalNotes().length"></span>
                                                <h2>Internal<br>Comments</h2>
                                            </button>
                                        </div>
                                    </div>                                

                                    <div class="form-group form-comment" id="application-history-section">
                                       <h3 class="form-sub-title no-margin icon i-samples app-history">Application History</h3>
                                    </div>
                                    <div class="form-group">
                                        <div class="w-list-results">
                                            <!-- ko if: applicationHistory().length > 0 -->
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Position</span></th>
                                                        <th><span>Application <br> Status</span></th>
                                                        <th><span>Steps <br> Completed</span></th>
                                                        <th><span>HR Status</span></th>
                                                        <th><span>Rejection <br> Reason</span></th>
                                                        <th class="time-width"><span>Date Created</span></th>
                                                        <th class="time-width"><span>Date Updated</span></th>                                                    
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: applicationHistory">
                                                    <tr class="cursor" data-bind="click: function() { window.open(jobApplicationLink, '_blank') }, attr: { 'data-application-id': applicationId }">
                                                        <td>
                                                            <div class="flex">
                                                                <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: positionName"></span>
                                                            </div>
                                                        </td>
                                                        <td><span data-bind="text: applicationStatus"></span></td>
                                                        <td><span data-bind="text: stepsCompleted"></span> / <span data-bind="text: totalSteps"></span></td>
                                                        <td><span data-bind="text: hrStatus"></span></td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->
                                                            <h2 class="rejection-title" data-bind="css: { red: idRejectionReason > 0 && idRejectionReason <= 6, yellow: idRejectionReason > 6 },text: reasonForRejection"></h2>               
                                                            <p class="rejection-info">  By  
                                                            <span class="rejection-info" data-bind="text: rejectedBy"></span>               
                                                            </p>
                                                            <p class="rejection-info" data-bind="text: rejectionTime"></p>               
                                                            <!-- /ko -->
                                                        </td>
                                                        <td class="time-width"><span data-bind="text: dateCreated"></span></td>
                                                        <td class="time-width"><span data-bind="text: dateUpdated"></span></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <!-- /ko -->
                                            <!-- ko if: applicationHistory().length == 0 -->

                                            <h2 class="form-title no-margin">No Application History Found</h2>
                                            <!-- /ko -->
                                        </div>
                                    </div>
                                    <div class="form-group form-comment" id="brand-access-notes-section">
                                       <h3 class="form-sub-title no-margin icon i-brand brand-history">Brand Access Notes</h3>
                                    </div>                                    
                                    <div class="form-group">
                                        <!-- ko if: offboardingHistory().length > 0 -->

                                        <div class="w-list-results">
                                            <table class="list-results">
                                                <thead>
                                                    <tr>
                                                        <th><span>Brand Status</span></th>
                                                        <th><span>Offboarding Reason</span></th>
                                                        <th><span>Article Count</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody data-bind="foreach: offboardingHistory">
                                                    <tr>
                                                        <td>
                                                            <div class="flex">
                                                               <span data-bind="css: brandIconImage" class="dark full-icon"></span><span data-bind="text: brandStatus"></span>
                                                            </div>
                                                        </td>
                                                        <td class="rejection-reason">
                                                            <!-- ko if: idRejectionReason > 0 -->
                        
                                                            <h2 class="rejection-title" data-bind="css: { 'hide': idRejectionReason === 0, 'red': rejectionColor =='red', 'yellow': rejectionColor == 'yellow' }, text: idRejectionReason === 0 ? '' :  offboardingReason"></h2>
                                                            <p class="rejection-info">
                                                                <span class="rejection-info" data-bind="text: 'By ' + offboardingResponsible"></span>  
                                                            </p>
                                                            <p class="rejection-info">
                                                                <span  class="rejection-info" data-bind="text: offboardingTimestamp"></span>             
                                                            </p>
                                                            <!-- /ko -->
                                                        </td>
                                                        <td>
                                                            <div class="flex" style="flex: none;">
                                                                <span style="flex: none; width: 6rem" data-bind="text: articleCount"></span>
                                                                <a class="btn icon border only-icon i-link" data-bind="attr:{href: articlesLink}" target="_blank"> </a>
                                                            </div>    
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <!-- /ko -->
                                        <!-- ko if: offboardingHistory().length == 0 -->
                                        <div class="form-group">
                                        </div>
                                        <div class="form-group no-result">
                                            <span class="icon i-brand"></span>
                                            <h2 class="form-title no-margin">No Brand Access Notes Found</h2>
                                        </div>                                        
                                        <!-- /ko -->                                        
                                    </div>
                                    <div class="form-group form-comment" id="internal-comments-section">
                                       <h3 class="form-sub-title no-margin icon i-notes internal-notes">Internal Comments</h3>
                                    </div>                          
                                    <!-- ko if: internalNotes().length > 0 -->
                                    <div class="form-group form-comment">

                                        <ul data-bind="foreach: internalNotes">
                                            <li>
                                               
                                                <div class="flex space border">
                                                    <div class="flex">
                                                        <span class="user icon i-user" data-bind="text: fullName"></span>
                                                        <span> &nbsp;|&nbsp; </span>
                                                        <span class="details" data-bind="text: dateCreated"> </span>
                                                        <span> &nbsp;|&nbsp; </span>
                                                        <a class="details" data-bind="text: profileName, attr:{href: jobApplicationLink}" target="_blank"> </a>
                                                     
                                                    </div>
                                                    <!-- ko if: $parent.permissions()['job_application_internal_comments'].write || $parent.idLoggedUser() == userId -->
                                                    <button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp.bind($data, 1) }" class="btn border only-icon icon i-delete"></button>
                                                    <!-- /ko -->
                                                </div>
                                                 <p class="comment" data-bind="text: comment"> </p>
                             
                                            </li>
                                        </ul>

                                    </div>                                          
                                  
                                    <!-- /ko -->
                                    <!-- ko if: internalNotes().length == 0 -->
                                    <div class="form-group">
                                        <div class="form-group no-result">
                                            <span class="icon i-notes"></span>
                                            <h2 class="form-title no-margin">No Internal Comments Found</h2>
                                        </div>                                    
                                    </div>                                    
                                    <!-- /ko -->   
                                      <div class="form-group">
                                        <label for="comments" class="form-label">Add a Comment</label>
                                        <textarea id="comments" style="max-width: none" data-bind="value: internalNote" type="text" class="input-text input-text-comment"></textarea>
                                    </div>
                                    <div class="form-group" style="text-align: right">
                                        <button data-bind="event: { click: onClickAddComment.bind($data, 1) }" class="btn border only-icon icon i-submitted" style="margin-top: -1rem" type="button"><span class="hidden-text">Send</span></button>
                                    </div>                                    
                                </div>

                            </div>
                        
                        </div>
                      
                    </div>
                    
                    <div class="w-form w-form-side">
                        <div class="form-header">
                            <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                            <button data-bind="event: { click: onClickShowAdminConfirmPopUp }" class="btn highlight" type="button">Save</button>
                            <!-- ko if: isCandidate() && status() && status().id == '1'-->
                            <button data-bind="event: { click: onClickShowConfirmPopUp }" class="btn highlight" type="button">Submit</button>    
                            <!-- /ko --> 
                        </div>
                        <div class="w-status-bar">
                            <div class="status-left">
                            
                                <!-- ko if: !permissions()['job_application_hr_flag'].write  && hrStatus() && !isCandidate() -->
                                <span data-bind="css: ((hrStatus().id == '1' ? 'status status-pending icon i-pending' : ((hrStatus().id == '2') ? 'status status-approved icon i-approved' :'status status-rejected icon i-rejected')))">
                                    <span data-bind="text: 'HR ' + hrStatus().name"></span>
                                </span>
                                <!-- /ko -->
                                <!-- ko if: !permissions()['job_application_status'].write && status()-->
                                <span data-bind="css: statusClass()">
                                    <span data-bind="text: 'Application ' + status().name"></span>
                                </span>
                                <!-- /ko -->
                                
                                <!-- ko if: permissions()['job_application_hr_flag'].write -->
                                <div class="form-group row">
                                    <label for="type" class="form-label">HR Status</label>
                                    <select id="type" data-bind="options: hrStatusOptions, value: idHrStatus, optionsText: 'name', optionsValue: 'id'"></select>
                                </div>
                                <!-- /ko -->
                                <!-- ko if: permissions()['job_application_status'].write && isStatusShown() -->
                                <div class="form-group row" style="margin-top: 1.5rem">
                                    <label for="type" class="form-label">Application Status</label>
                                    <select id="type" data-bind="disable: (hrStatus().id != '2') ,options: applicationStatusOptions, value: idApplicationStatus, optionsText: 'name', optionsValue: 'id'"> </select>
                                </div>
                                <!-- /ko -->
                           
                            </div>  
                             
                            <div class="status-right">
                                <span data-bind="css:{ 'is-complete' : stepsCompleted() > 0 && totalSteps() > 0 && stepsCompleted()/totalSteps() == 1 }"><span data-bind="text: stepsCompleted()+'/'+totalSteps()"></span>steps completed</span>
                            </div> 
                              
                        </div>
                        
                        <div class="w-form-body sticky" id="external-comments">
                            <div class="form-body full-width">
                                <strong class="form-sub-title">Chat</strong>
                                <div class="form-group">
                                    <label for="comments" class="form-label">Send A Message</label>
                                    <textarea id="comments" data-bind="value: comment" class="input-text input-text-comment"></textarea>
                                </div>
                                <div class="form-group" style="text-align: right">
                                    <button data-bind="event: { click: onClickAddComment.bind($data, 0) }" class="btn border only-icon icon i-submitted" type="button"><span class="hidden-text">Send</span></button>
                                </div>

                                <div class="form-group form-comment">
                                    <ul data-bind="foreach: comments">
                                        <li>
                                            <div class="flex space border">
                                                <div class="flex">
                                                    <!-- ko if: user -->
                                                    <span class="user icon i-user" data-bind="text: user.valnet_user.fullName"></span>
                                                    <!-- /ko -->
                                                    <span> &nbsp;|&nbsp; </span>
                                                    <span class="details" data-bind="text: dateCreated"> </span>                                                
                                                </div>
                                                <!-- ko if: $data.canDelete && $parent.idLoggedUser() == user.id -->
                                                <button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp.bind($data, 0) }" class="btn border only-icon icon i-delete"></button>
                                                <!-- /ko -->
                                            </div>
                                            <p class="comment" data-bind="text: comment"> </p>
                                            
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting Comment</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>
                       
                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to delete the comment:</p>
                                    <span data-bind="text: deletingObject().comment"></span>
                                </div>
                             </div>
                    
                            <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onSaveDeleteComment }" class="btn border only-icon icon i-delete">Delete</button>
                        </div>
                        </div>
                    </div> 
                </div>
                
                <div id="confirm-dialog" class="w-lightbox light-theme">
                     <div class="lightbox-content">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">CONFIRM APPLICATION SUBMISSION</h3>
                                <button type="button"  data-bind="event: { click: onClickHideConfirmPopUp }" class="close-button icon i-close-2"></button>
                            </div>
                       
                                <div class="form-body">
                                <div class="form-group">
                                    <span data-bind="text: statusUpdateWarningMessage"></span>
                                </div>
                            </div>
                    
                            <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideConfirmPopUp }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onSaveSubmitStatus }" class="btn border only-icon icon i-save">Submit</button>
                            </div>
                        </div>
                    </div> 
                </div>
                
                <div id="confirm-dialog-admin" class="w-lightbox light-theme">
                    <div class="lightbox-content rejection-pop-up">
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Confirm Status Update</h3>
                                <button type="button"  data-bind="event: { click: onClickHideAdminConfirmPopUp }" class="close-button icon i-close-2"></button>
                            </div>
                       
                                <div class="form-body">
                                <div class="form-group">
                                    <span data-bind="text: statusUpdateWarningMessage"></span>
                                </div>

                                <div class="form-group" data-bind="visible: showReasonDropdown">
                                    <label for="reason-dropdown">Rejection Reason:</label>
                                    <select required="required" id="reason-dropdown" data-bind="css: selectedReasonColor ,value: selectedReason, options: rejectionReasons, optionsText: 'name', optionsValue: 'id', optionsCaption: 'Select',event: { change: onReasonChange }"></select>
                                </div>
                        
                                 
                            </div>
                    
                            <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHideAdminConfirmPopUp }" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon i-save">Submit</button>
                        </div>
                    </div> 
                </div>
                
            `;
    }

    protected initPartial(): void {

        this.resumeTooltip = new infoButton_template('resumeTooltip', this.getTemplateViewModel(), this.caller)
        this.resumeTooltip.setTitle('Allowed File Types');
        this.resumeTooltip.setContent('<p>.pdf, .txt, .rtf, .doc, .docx</p>');

        this.coverLetterTooltip = new infoButton_template('coverLetterTooltip', this.getTemplateViewModel(), this.caller)
        this.coverLetterTooltip.setTitle('Allowed File Types');
        this.coverLetterTooltip.setContent('<p>.pdf, .txt, .rtf, .doc, .docx</p>');

        this.imagesSampleTooltip = new infoButton_template('imagesSampleTooltip', this.getTemplateViewModel(), this.caller)
        this.imagesSampleTooltip.setTitle('Allowed File Types');
        this.imagesSampleTooltip.setContent('<p>.pdf, .jpg, .jpeg, .png, .x-png, .gif</p>');

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "jobApplicationsEdit-form-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {

              id: ko.observable("")
            , candidateName: ko.observable("")
            , candidateEmail: ko.observable("")
            , positionTitle: ko.observable("")
            , userRoles: ko.observable("")
            , country: ko.observable("")
            , userBrands: ko.observableArray([])
            , candidateProfileLink: ko.observable("")
            , jobProfileViewLink: ko.observable("")
            , jobProfileImageUrl: ko.observable("")
            , status : ko.observable()
            , statusClass : ko.observable()
            , hrStatus : ko.observable()
            , writtenSampleText: ko.observable("") //old
            , resume: ko.observable("")
            , resumeFile: ko.observable("")
            , coverLetter: ko.observable("")
            , coverLetterFile: ko.observable("")
            , referentialWork: ko.observable("")
            , writtenSample: ko.observable("")
            , writtenSampleFile: ko.observable("")
            , imageSample: ko.observable("")
            , imageSampleFiles: ko.observableArray([])
            , answers: ko.observable("")
            , brandIcon: ko.observable("")
            , isSampleSubmitted: ko.observable(false)
            , isStatusShown: ko.observable(false)
            , isCandidate: ko.observable(false)
            , permissions: ko.observableArray(this.initPermissions(['job_application_hr_flag','job_application_status', 'job_profiles', 'users_list', 'job_application_internal_comments']))
            , comment: ko.observable("")
            , comments: ko.observableArray([])
            , internalNote: ko.observable("")
            , internalNotes: ko.observableArray([])
            , idHrStatus: ko.observable()
            , initialIdHrStatus: ko.observable()
            , hrStatusOptions: ko.observableArray([])
            , idApplicationStatus: ko.observable()
            , initialIdApplicationStatus: ko.observable()
            , applicationStatusOptions: ko.observableArray([])
            , deletingObject: ko.observable({'comment':null})
            , isDeletingInternalComment: ko.observable(0)
            , totalSteps: ko.observable(0)
            , stepsCompleted: ko.observable(0)
            , stepsDetails: ko.observableArray([])
            , selectedTab: ko.observable('application')
            , total: ko.observable(0)
            , documentCompleted: ko.observable(0)
            , samplesCompleted: ko.observable(0)
            , linksCompleted: ko.observable(0)
            , answersCompleted: ko.observable(0)
            , percentage: ko.observable(0)
            , idLoggedUser: ko.observable("")
            , statusUpdateWarningMessage: ko.observable('')
            , rejectionReasons: ko.observableArray([])
            , showReasonDropdown: ko.observable(false)
            , selectedReason: ko.observable('')
            , selectedReasonColor: ko.observable('')
            , applicationHistory: ko.observableArray([])
            , offboardingHistory: ko.observableArray([])
            , onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            },
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            removeFile: function (data, event) {
                huit_neuf_this.removeFile(data)
            },
            onClickAddComment: function (value,data, event) {
                huit_neuf_this.onClickAddComment(value);
            },
            onClickShowDeletePopUp: function(value, data, event){
                huit_neuf_this.onClickShowDeletePopUp(value, data)
            },
            onClickHideDeletePopUp: function(data, event) {
                huit_neuf_this.onClickHideDeletePopUp()
            },
            onSaveDeleteComment:function (data, event) {
                  huit_neuf_this.onSaveDeleteComment()
            },
            onUpdateReferentialLink: function(data, event) {
                huit_neuf_this.onUpdateReferentialLink()
            },
            onUpdateAnswer: function(data, event) {
                huit_neuf_this.onUpdateAnswer()
            },
            onClickShowConfirmPopUp: function(data, event){
                  huit_neuf_this.onClickShowConfirmPopUp()
            },
            onClickHideConfirmPopUp: function(data, event){
                  huit_neuf_this.onClickHideConfirmPopUp()
            },
            onSaveSubmitStatus:function (data, event) {
                  huit_neuf_this.onSaveSubmitStatus()
            },
            onClickTab: function (value, data, event) {
                  huit_neuf_this.onClickTab(value)
              }
              ,
            onClickShowAdminConfirmPopUp: function ( data, event) {
                huit_neuf_this.onClickShowAdminConfirmPopUp()
            },
            onClickHideAdminConfirmPopUp: function ( data, event) {
                huit_neuf_this.onClickHideAdminConfirmPopUp()
            }
            , onReasonChange:function (data, event) {huit_neuf_this.onReasonChange(data,event)}
            , getReasonColor:function (data, event) {huit_neuf_this.getReasonColor(data)}

        };
    }

    protected getReasonColor(reason){
        const allReasons = this.getTemplateViewModel().rejectionReasons();
        const reasonObj = allReasons.find(r => r.id === reason);
        return reasonObj ? reasonObj.color : `Unknown Reason (ID: ${reason})`;
    }

    public onClickShowAdminConfirmPopUp(){
        let vnApp = this.caller.getVnAppZone().app;
        let dateTime = new Date().toLocaleString("en-US", {
            timeZone: "America/Toronto",
        });
        let type = '';
        if(this.getTemplateViewModel().initialIdHrStatus() !== this.getTemplateViewModel().idHrStatus()){
            if(this.getTemplateViewModel().idHrStatus() === 3){
                this.getTemplateViewModel().showReasonDropdown(true);
                type = 'HR';
            }
            else{
                this.getTemplateViewModel().showReasonDropdown(false);
            }
        }  
         else if(this.getTemplateViewModel().initialIdApplicationStatus() !== this.getTemplateViewModel().idApplicationStatus()){
                if(this.getTemplateViewModel().idApplicationStatus() === 4){
                    this.getTemplateViewModel().showReasonDropdown(true);
                    type = 'Application';
                }
                else{
                    this.getTemplateViewModel().showReasonDropdown(false);
                }
        }
        
        if (this.getTemplateViewModel().showReasonDropdown()) {
            let warningMessage = type + ' status will be updated to Rejected by ' + vnApp.loggedUser.user.valnet_user.fullName + ' at ' + dateTime;;
            this.getTemplateViewModel().statusUpdateWarningMessage(warningMessage)
            this.toggleAdminConfirmDialogVisibility();
        }
        else{
            this.onClickSave()
        }        
    }


    public onClickHideAdminConfirmPopUp(){

        this.getTemplateViewModel().statusUpdateWarningMessage('');
        this.toggleAdminConfirmDialogVisibility();
    }

    public toggleAdminConfirmDialogVisibility(){

        document.getElementById('confirm-dialog-admin').classList.toggle('is-visible');
    }

    onReasonChange = (data: any, event: any) => {
        const selectedId = parseInt(event.target.value);
        this.getTemplateViewModel().selectedReasonColor(this.getReasonColor(selectedId));
        this.getTemplateViewModel().selectedReason(selectedId);

    }
    public onClickSave() {

        let reason = this.getTemplateViewModel().selectedReason();

        if (this.getTemplateViewModel().showReasonDropdown()) {
           if(!reason) {
               alert("Please select a reason.");
               return;
           }
       }

       
        this.getTemplateViewModel().isSampleSubmitted(false);
        this.caller.save();
    }

    public onClickCancel() {
        this.caller.cancelForm();
    }

    public removeFile(data){

        this.getTemplateViewModel().images.remove(data);
        this.caller.onClickDeleteImage();
    }

    public onClickShowDeletePopUp(value, data){

        this.getTemplateViewModel().isDeletingInternalComment(value)
        this.getTemplateViewModel().deletingObject(data);
        this.toggleDeleteDialogVisibility();
    }

    public onClickHideDeletePopUp(){

        this.getTemplateViewModel().deletingObject({'comment': null});
        this.toggleDeleteDialogVisibility();
    }

    public toggleDeleteDialogVisibility(){

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public onSaveDeleteComment(){

        let comment = this.getTemplateViewModel().deletingObject();
        let isInternal = this.getTemplateViewModel().isDeletingInternalComment();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteComment(comment, isInternal);
    }

    public onClickAddComment(value){

        this.caller.addComment(value)
    }

    public setIdLoggedUser(idLoggedUser): void{

        this.getTemplateViewModel().idLoggedUser(idLoggedUser);
    }

    public setIsCandidate(isCandidate){

        this.getTemplateViewModel().isCandidate(isCandidate);
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setHrStatusOptions(hrStatusOptions){

        this.getTemplateViewModel().hrStatusOptions(hrStatusOptions);
    }

    public setApplicationStatusOptions(applicationStatusOptions){

        this.getTemplateViewModel().applicationStatusOptions(applicationStatusOptions);
    }
    public setRejectionReasons(rejectionReasons){

        this.getTemplateViewModel().rejectionReasons(rejectionReasons);
    }
    public setUpForm(application): void {

        this.getTemplateViewModel().id(application.id);
        this.getTemplateViewModel().candidateName(application.fullName);
        this.getTemplateViewModel().candidateEmail(application.email);
        this.getTemplateViewModel().status(application.applicationStatus);
        this.getTemplateViewModel().idApplicationStatus(application.applicationStatus.id);
        this.getTemplateViewModel().initialIdApplicationStatus(application.applicationStatus.id);
        this.getTemplateViewModel().hrStatus(application.hrStatus);
        this.getTemplateViewModel().idHrStatus(application.hrStatus.id);
        this.getTemplateViewModel().initialIdHrStatus(application.hrStatus.id);
        this.getTemplateViewModel().positionTitle(application.originalProfile.name);
        this.getTemplateViewModel().resume(application.resume);
        this.getTemplateViewModel().resumeFile(application.resumeFile);
        this.getTemplateViewModel().coverLetter(application.coverLetter);
        this.getTemplateViewModel().coverLetterFile(application.coverLetterFile);
        this.getTemplateViewModel().writtenSample(application.writtenSample);
        this.getTemplateViewModel().writtenSampleFile(application.writtenSampleFile);
        this.getTemplateViewModel().imageSample(application.imageSample);
        this.getTemplateViewModel().imageSampleFiles(application.imageSampleFiles);
        this.getTemplateViewModel().writtenSampleText(application.instructionText ? application.instructionText : null);
        this.getTemplateViewModel().jobProfileImageUrl(application.originalProfile.imageUrl);
        this.getTemplateViewModel().jobProfileViewLink(window.location.origin+'/job/profiles/view/'+application.originalProfile.id);
        this.getTemplateViewModel().brandIcon(application.originalBrand.iconImage);

        this.setComments(application.comments)
        this.setStatusClass(application.applicationStatus);

        this.setReferentialWork(application.referentialWork)
        this.setQuestionAndAnswers(application.answers)

        if(application.resume && application.resume.id > 1) {
            this.generateDropzoneResume(application);
        }
        if(application.coverLetter && application.coverLetter.id > 1) {
            this.generateDropzoneCoverLetter(application);
        }
        if(application.writtenSample && application.writtenSample.id > 1) {
            this.generateDropzoneWrittenSample(application);
        }
        if(application.imageSample && application.imageSample.id > 1) {
            this.generateDropzonePicture(application);
        }

        //only show status dropdown if status is not approved
        if(application.applicationStatus.id != 3) {
            this.getTemplateViewModel().isStatusShown(true);
        }

        if(application.user){
            this.getTemplateViewModel().userBrands(application.user.brands ? application.user.brands : []);
            this.getTemplateViewModel().country(application.user.valnet_user.country ? application.user.valnet_user.country.name : '')
            this.getTemplateViewModel().candidateProfileLink(window.location.origin+'/users/profile/'+application.user.id)

            let roles = application.user.valnet_user.roles;
            let userRoles = "";
            for(let role of roles){

                userRoles = userRoles + role.name + ", ";
            }
            userRoles = userRoles.substring(0,  userRoles.length - 2);
            this.getTemplateViewModel().userRoles(userRoles);
        }

        this.initialStepsCount(application);
    }

    public setReferentialWork(referentialWork){

        if(referentialWork) {

            let links = referentialWork.links;
            let linksObservables = [];


            for (let i=0; i < 3; i++) {

                if(links && links[i]){

                    linksObservables.push(ko.observable(links[i]));
                }else{
                    linksObservables.push(ko.observable(''));
                }
            }

            referentialWork.links = linksObservables;

            this.getTemplateViewModel().referentialWork(referentialWork);
        }
    }

    public setQuestionAndAnswers(items){

        if(items) {

            for (let item of items) {

                item.answer = ko.observable(item.answer)
            }

            this.getTemplateViewModel().answers(items);
        }
    }

    public setComments(comments){

        let date24HoursAgo = new Date();
        date24HoursAgo.setHours(date24HoursAgo.getHours() - 24);

        for(let comment of comments){
            let dateCreated = new Date(comment.dateCreated);

            //only allow comment delete if less than 24 hours old
            if (dateCreated < date24HoursAgo){
                comment.canDelete = false;
            }else{
                comment.canDelete = true;
            }

        }
        this.getTemplateViewModel().comments(comments);
    }

    public setInternalNotes(internalNotes){

        for(let internalNote of internalNotes){

            internalNote.jobApplicationLink = window.location.origin +'/job/applications/view/' + internalNote.applicationId;
        }

        this.getTemplateViewModel().internalNotes(internalNotes);
    }

    protected setApplicationHistory(applicationHistory){

        for(let application of applicationHistory){

            application.jobApplicationLink = window.location.origin +'/job/applications/view/' + application.applicationId;
        }

        this.getTemplateViewModel().applicationHistory(applicationHistory);
    }
    protected setOffboardingHistory(offboardingHistory){

        for(let offboarding of offboardingHistory){

            offboarding.articlesLink = window.location.origin +'/brand/'+offboarding.idBrand+'/articles/?authors=%5B%7B"id"%3A'+offboarding.idAuthor+'%2C"name"%3A"'+offboarding.userName+'"%7D%5D' ;
        }

        this.getTemplateViewModel().offboardingHistory(offboardingHistory);
    }

    protected setStatusClass(data){

        switch (data.id){
            case 1:
                this.getTemplateViewModel().statusClass('status status-pending icon i-pending');
                break;
            case 2:
                this.getTemplateViewModel().statusClass('status status-submitted icon i-submitted');
                break;
            case 3:
                this.getTemplateViewModel().statusClass('status status-approved icon i-approved');
                break;
            case 4:
                this.getTemplateViewModel().statusClass('status status-rejected icon i-rejected');
                break;
            case 5:
                this.getTemplateViewModel().statusClass('status status-cancel icon i-rejected');
                break;
            default:
                break;
        }
    }

    protected generateDropzoneResume(application) {

        let element = document.getElementById('my-drop-zone-resume');
        let myDropzoneResume= new Dropzone(element, {
            url: "/api/job/applications/uploadImage/"+ application.id,
            maxFiles: 1,
            maxFilesize: 3,
            addRemoveLinks: true ,
            acceptedFiles: "application/pdf, text/plain, application/rtf, text/rtf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            params:{ section: 'resume'}
        });

        let _this = this;

        myDropzoneResume.on("success", function (file, serverFileName) {
            let responseParsed = serverFileName;
            _this.getTemplateViewModel().resumeFile(responseParsed.data[0]);
            _this.onChangeApplicationFiles();
        });

        myDropzoneResume.on("error", function (file, response) {
            this.removeFile(file);
            let validations = response.validations;
            if(validations) {
                _this.validationsList.setMessages(validations);
                window.scrollTo(0, 0);
            }
        });

        myDropzoneResume.on("addedfile", function(file) {
            _this.validationsList.clearMessages();
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });

        myDropzoneResume.on("removedfile", function() {
            _this.getTemplateViewModel().resumeFile('');
            _this.onChangeApplicationFiles();
        });

        if(application.resumeFile){

            let mockFile = { name: application.resumeFile.path, size: application.resumeFile.size};

            myDropzoneResume.emit("addedfile", mockFile);
            myDropzoneResume.createThumbnailFromUrl(mockFile, mockFile.name);
            myDropzoneResume.emit("complete", mockFile);
            myDropzoneResume.files.push(mockFile);
            _this.getTemplateViewModel().resume(application.resume);
        }
    }

    protected generateDropzoneCoverLetter(application) {

        let element = document.getElementById('my-drop-zone-coverLetter');
        let myDropzoneCoverLetter= new Dropzone(element, {
            url: "/api/job/applications/uploadImage/"+ application.id,
            maxFiles: 1,
            maxFilesize: 3,
            addRemoveLinks: true,
            acceptedFiles: "application/pdf, text/plain, application/rtf, text/rtf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            params:{ section: 'coverLetter'}
        });

        let _this = this;

        myDropzoneCoverLetter.on("success", function (file, serverFileName) {
            let responseParsed = serverFileName;
            _this.getTemplateViewModel().coverLetterFile(responseParsed.data[0]);
            _this.onChangeApplicationFiles();
        });

        myDropzoneCoverLetter.on("error", function (file, response) {
            this.removeFile(file);
            let validations = response.validations;
            if(validations) {
                _this.validationsList.setMessages(validations);
                window.scrollTo(0,0)
            }
        });

        myDropzoneCoverLetter.on("addedfile", function(file) {
            _this.validationsList.clearMessages();
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            }
        });

        myDropzoneCoverLetter.on("removedfile", function() {
            _this.getTemplateViewModel().coverLetterFile('');
            _this.onChangeApplicationFiles();
        });

        if(application.coverLetterFile){

            let mockFile = { name: application.coverLetterFile.path, size: application.coverLetterFile.size};

            myDropzoneCoverLetter.emit("addedfile", mockFile);
            myDropzoneCoverLetter.createThumbnailFromUrl(mockFile, mockFile.name);
            myDropzoneCoverLetter.emit("complete", mockFile);
            myDropzoneCoverLetter.files.push(mockFile);
            _this.getTemplateViewModel().coverLetter(application.coverLetter);
        }
    }

    protected generateDropzoneWrittenSample(application) {

        let element = document.getElementById('my-drop-zone-writtenSample');
        if(element) {

            let myDropzoneWrittenSample = new Dropzone(element, {
                url: "/api/job/applications/uploadImage/" + application.id,
                maxFiles: 1,
                maxFilesize: 3,
                addRemoveLinks: true,
                acceptedFiles: "application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                params: {section: 'writtenSample'}
            });

            let _this = this;

            myDropzoneWrittenSample.on("success", function (file, serverFileName) {
                let responseParsed = serverFileName;
                _this.getTemplateViewModel().writtenSampleFile(responseParsed.data[0]);
                _this.onChangeWrittenSample();
            });

            myDropzoneWrittenSample.on("error", function (file, response) {
                this.removeFile(file);
                let validations = response.validations;
                if (validations) {
                    _this.validationsList.setMessages(validations);
                    window.scrollTo(0, 0)
                }
            });

            myDropzoneWrittenSample.on("addedfile", function (file) {
                if (this.files.length > 1) {
                    this.removeFile(this.files[0]);
                }
            });

            myDropzoneWrittenSample.on("removedfile", function () {
                _this.getTemplateViewModel().writtenSampleFile('');
                _this.onChangeWrittenSample();
            });

            if (application.writtenSampleFile) {

                let mockFile = {name: application.writtenSampleFile.path, size: application.writtenSampleFile.size};

                myDropzoneWrittenSample.emit("addedfile", mockFile);
                myDropzoneWrittenSample.createThumbnailFromUrl(mockFile, mockFile.name);
                myDropzoneWrittenSample.emit("complete", mockFile);
                myDropzoneWrittenSample.files.push(mockFile);
                _this.getTemplateViewModel().writtenSample(application.writtenSample);
            }
        }
    }

    protected generateDropzonePicture(application) {

        let element = document.getElementById('my-drop-zone-picture');
        let myDropzonePicture= new Dropzone(element, {
            url: "/api/job/applications/uploadImage/"+ application.id,
            maxFiles: 3,
            parallelUploads: 3,
            uploadMultiple: true,
            addRemoveLinks: true,
            acceptedFiles: "application/pdf,image/jpg,image/jpeg,image/png,image/x-png,image/gif",
            params:{ section: 'ImageSample'}
        });

        let _this = this;

        myDropzonePicture.on("successmultiple", function (files, serverFileName) {
            let responseParsed = serverFileName;
            let uploadedFiles = responseParsed.data;
            let errors = responseParsed.errors;
            let failedFiles = responseParsed.failedFiles;
            if(errors.length > 0){
                _this.validationsList.setMessages(errors);
                for(let file of files){
                    if(failedFiles.includes(file.name)) {
                        this.removeFile(file);
                    }
                }

            }
            uploadedFiles.forEach(function (element) {
                _this.getTemplateViewModel().imageSampleFiles.push(element);
            });
            _this.onChangeSampleImages();
        });

        myDropzonePicture.on("errormultiple", function (files, response) {
            this.removeFile(files);
            let validations = response.validations;
            if(validations) {
                _this.validationsList.setMessages(validations);
                window.scrollTo(0, 0)
            }
            _this.onChangeSampleImages();
        });

        myDropzonePicture.on("addedfile", function(file) {
            _this.validationsList.clearMessages();
            if (this.files.length > 3) {
                window.alert("You cannot upload more than three images. If you would like to add another, please remove an existing image." );
                this.removeFile(file);
            }
        });

        myDropzonePicture.on("removedfile", function(file) {
            _this.getTemplateViewModel().imageSampleFiles.remove(function(item) {
                return item.path == file.name;
            });
            _this.onChangeSampleImages();
        });

        if(application.imageSampleFiles){

            application.imageSampleFiles.forEach(function (element) {
                let mockFile = { name: element.path, size: element.size};
                myDropzonePicture.emit("addedfile", mockFile);
                myDropzonePicture.createThumbnailFromUrl(mockFile, mockFile.name);
                myDropzonePicture.emit("complete", mockFile);
                myDropzonePicture.files.push(mockFile);
            });
        }
    }

    protected onChangeApplicationFiles(){

        let stepsDetails = this.getTemplateViewModel().stepsDetails();
        if(stepsDetails['files']){

            let count = 0;
            let resumeFile = this.getTemplateViewModel().resumeFile();
            let coverLetterFile = this.getTemplateViewModel().coverLetterFile();

            if(resumeFile){
                count++;
            }
            if(coverLetterFile){
                count++;
            }
            stepsDetails['files'].completed = count;
            this.getTemplateViewModel().stepsDetails(stepsDetails);
        }
        this.countCompletedSteps();
    }

    protected onChangeWrittenSample(){

        let stepsDetails = this.getTemplateViewModel().stepsDetails();
        if(stepsDetails['writtenSample']){

            let writtenSampleFile = this.getTemplateViewModel().writtenSampleFile();
            if(writtenSampleFile){
                stepsDetails['writtenSample'].completed = 1;
            }else {
                stepsDetails['writtenSample'].completed = 0;
            }
            this.getTemplateViewModel().stepsDetails(stepsDetails);
        }
        this.countCompletedSteps();
    }

    protected onChangeSampleImages(){

        let stepsDetails = this.getTemplateViewModel().stepsDetails();
        if(stepsDetails['imageSample']){

            let files = this.getTemplateViewModel().imageSampleFiles();
            stepsDetails['imageSample'].completed = files.length;
            this.getTemplateViewModel().stepsDetails(stepsDetails);
        }
        this.countCompletedSteps();
    }

    protected onUpdateReferentialLink(){

        let stepsDetails = this.getTemplateViewModel().stepsDetails();
        if(stepsDetails['referentialWork']){

            let count = 0;
            let data = this.getTemplateViewModel().referentialWork();
            for (let link of data.links) {
                if (link() != '') {
                    count++;
                }
            }

            stepsDetails['referentialWork'].completed = count;
            this.getTemplateViewModel().stepsDetails(stepsDetails);
        }
        this.countCompletedSteps();
    }



    protected onUpdateAnswer(){

        let stepsDetails = this.getTemplateViewModel().stepsDetails();
        if(stepsDetails['answers']){

            let count = 0;
            let answers = this.getTemplateViewModel().answers();
            for (let answer of answers) {
                if (answer.answer() != '' && (answer.id == 2 || answer.id == 3 )) {
                    count++;
                }
            }

            stepsDetails['answers'].completed = count;
            this.getTemplateViewModel().stepsDetails(stepsDetails);
        }
        this.countCompletedSteps();
    }

    protected initialStepsCount(data) {

        let stepsDetails = [] ;
        let keys = ['files', 'referentialWork', 'writtenSample', 'imageSample', 'answers']

        for (let key of keys) {

            let step = { total : 0, required: 0, completed : 0, current : 0};
            step = this.updateStep(key, data, step);
            step.current = this.getTemplateViewModel().totalSteps();
            stepsDetails[key] = step;
        }
        this.getTemplateViewModel().stepsDetails(stepsDetails);
        this.countCompletedSteps();
    }

    protected updateStep(key, data, step){

        if(!data){
            return ;
        }

        switch (key){
            case 'files':
                if((data.resume && data.resume.id > 1) || (data.coverLetter && data.coverLetter.id > 1)) {
                    this.getTemplateViewModel().totalSteps(this.getTemplateViewModel().totalSteps() + 1);
                    if (data.resume.id > 1) {
                        step.total++
                        if (data.resume.id == 2 || data.resume.id == 3) {
                            step.required++
                        }
                        if (data.resume.path != '') {
                            step.completed++;
                        }
                    }
                    if (data.coverLetter.id > 1) {
                        step.total++
                        if (data.coverLetter.id == 2 || data.coverLetter.id == 3) {
                            step.required++
                        }
                        if (data.coverLetter.path != '') {
                            step.completed++;
                        }
                    }
                }
                return step;
            case 'writtenSample':
                if(data.writtenSample && data.writtenSample.id > 1) {
                    this.getTemplateViewModel().totalSteps(this.getTemplateViewModel().totalSteps() + 1);
                    step.total++
                    if (data.writtenSample.id == 2 || data.writtenSample.id == 3) {
                        step.required++;
                    }
                    if (data.writtenSample.path != '' || data.instructionText ) {
                        step.completed++;
                    }
                }
                return step;
            case 'referentialWork':
                if(data.referentialWork && data.referentialWork.id > 1) {
                    this.getTemplateViewModel().totalSteps(this.getTemplateViewModel().totalSteps() + 1);
                    step.total = 3
                    if (data.referentialWork.id == 2 || data.referentialWork.id == 3) {
                        step.required++;
                    }
                    if (data.referentialWork.links && data.referentialWork.links.length > 0) {
                        for (let link of data.referentialWork.links) {
                            if (link() != '') {
                                step.completed++
                            };
                        }
                    }
                }
                return step;
            case 'imageSample':
                if(data.imageSample && data.imageSample.id > 1) {
                    this.getTemplateViewModel().totalSteps(this.getTemplateViewModel().totalSteps() + 1);
                    step.total = 3
                    if (data.imageSample.id == 2 || data.imageSample.id == 3) {
                        step.required++;
                    }
                    if (data.imageSample.path && data.imageSample.path.length > 0) {
                        for (let path of data.imageSample.path) {
                            if (path != '') {
                                step.completed++
                            };
                        }
                    }
                }
                return step;
            case 'answers':
                if(data.answers && data.answers.length > 0){
                    this.getTemplateViewModel().totalSteps(this.getTemplateViewModel().totalSteps() + 1);
                    step.total = data.answers.length;
                    for(let d of data.answers) {
                        if(d.id == 2 || d.id == 3){step.required++}
                        if(d.answer() != ''){step.completed++};
                    }
                }
                return step;
            default:
                break;
        }
    }

    protected countCompletedSteps(){

        let completed = 0;
        let steps = this.getTemplateViewModel().stepsDetails();

        for(let key in steps){

            if(steps[key].total > 0 && steps[key].completed >= steps[key].required){
                completed++;
            }
        }
        this.getTemplateViewModel().stepsCompleted(completed);
    }

    public onClickShowConfirmPopUp(){

        let warningMessage = 'Once submitted, the team will be notified and your candidacy will be considered.';
        this.getTemplateViewModel().statusUpdateWarningMessage(warningMessage)
        this.toggleConfirmDialogVisibility();
    }

    public onClickHideConfirmPopUp(){

        this.getTemplateViewModel().statusUpdateWarningMessage('');
        this.toggleConfirmDialogVisibility();
    }

    public toggleConfirmDialogVisibility(){

        document.getElementById('confirm-dialog').classList.toggle('is-visible');
    }

    public onSaveSubmitStatus(){

        this.getTemplateViewModel().isSampleSubmitted(true);
        this.caller.save();
        this.getTemplateViewModel().statusUpdateWarningMessage('');
        this.toggleConfirmDialogVisibility();
    }

    protected onClickTab(value){

        this.getTemplateViewModel().selectedTab(value)
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/jobApplicationsEdit_template.ts